import { useParams } from 'react-router-dom';

import Player from '../components/Player/Player';
import useTourVideo from '../hooks/useTourVideo/useTourVideo';

interface ClipsProps {
  videoId: string;
}

export default function Clips({ videoId }: ClipsProps) {
  const { tourId } = useParams();
  const { videoUrl, subtitlesUrl, isLoading } = useTourVideo(tourId, videoId);

  if (isLoading) {
    return null;
  }

  return <Player subtitlesUrl={subtitlesUrl} videoUrl={videoUrl} />;
}
